<div>
    <img src="/api/v1/auth/captcha?t={{now}}" alt="Captcha" />
    <mat-progress-bar [color]="'accent'" [mode]="'determinate'" [value]="counter" [bufferValue]="50">
    </mat-progress-bar>
</div>